import { initializeApp } from 'firebase/app'

export const firebaseApp = initializeApp({
	apiKey: 'AIzaSyA7DETIS-aVTZL5sIeTDAsNOMyCZCiwpEo',
	// Custom auth domain — same-site with app.nayda.pro, so OAuth cookies survive
	// browser storage partitioning (mobile Chrome ITP, in-app webviews, etc.).
	authDomain: 'auth.nayda.pro',
	projectId: 'nayda-grow',
	storageBucket: 'nayda-grow.firebasestorage.app',
	messagingSenderId: '335358433600',
	appId: '1:335358433600:web:95b791f83fb0e9aef542a5',
	measurementId: 'G-EY5WFHCBEY',
})
